import { render } from "./AirQuality.vue?vue&type=template&id=6e235ede&ts=true"
import script from "./AirQuality.vue?vue&type=script&lang=ts"
export * from "./AirQuality.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\Episcenter\\smartCity\\smartcity\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__